import { useEffect } from "react";
import { IErrorBoxProps } from "../../model/interface";
import './ErrorBox.scss';

export default function ErrorBox({ errorMessage }: IErrorBoxProps) {

    useEffect(() => {
        if (errorMessage) {
            document.getElementById("errorBox")?.focus();
        }
      
      }, [errorMessage])
    return (
        <span id="errorBox" className="error-box" data-testid="errorBox" role="alert">{errorMessage}</span>
    );
};
